// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"e_Vv","panel":"e_Wv","sheet":"e_Xv","conversation-sheet-up":"e_Yv","handle":"e_Zv","drawer":"e__v","conversation-drawer-in":"e_0v"};